/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LookerUrlDto } from '../../models/looker-url-dto';

export interface GetUrl$Params {
  reportId: number;
  tcId: number;
}

export function getUrl(http: HttpClient, rootUrl: string, params: GetUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<LookerUrlDto>> {
  const rb = new RequestBuilder(rootUrl, getUrl.PATH, 'get');
  if (params) {
    rb.path('reportId', params.reportId, {});
    rb.path('tcId', params.tcId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LookerUrlDto>;
    })
  );
}

getUrl.PATH = '/looker/{reportId}/{tcId}';
